import React, { useEffect, Suspense, lazy } from 'react';
import './styles/main.css';
import Header from './components/Header';
import Hero from './components/Hero';

// Below-the-fold sections are code-split so the heavy Three.js bundle
// isn't loaded until the user scrolls toward them, keeping the initial
// paint fast.
const ThesisProject = lazy(() => import('./components/ThesisProject'));
const RangerProject = lazy(() => import('./components/RangerProject'));
const OtherProjects = lazy(() => import('./components/OtherProjects'));
const Skills = lazy(() => import('./components/Skills'));
const Publications = lazy(() => import('./components/Publications'));
const Affiliations = lazy(() => import('./components/Affiliations'));
const EducationTimeline = lazy(() => import('./components/EducationTimeline'));
const Blog = lazy(() => import('./components/Blog'));
const Gallery = lazy(() => import('./components/Gallery'));
const CentrifugeExperience = lazy(() => import('./components/CentrifugeExperience'));
const Contact = lazy(() => import('./components/Contact'));
const Footer = lazy(() => import('./components/Footer'));

const SectionFallback = () => (
  <div className="section-loading" aria-busy="true" aria-live="polite">
    Loading…
  </div>
);

function App() {
  useEffect(() => {
    const handleSmoothScroll = (e) => {
      if (e.target.matches('a[href^="#"]')) {
        e.preventDefault();
        const targetId = e.target.getAttribute('href').substring(1);
        const targetElement = document.getElementById(targetId);
        if (targetElement) {
          targetElement.scrollIntoView({
            behavior: 'smooth'
          });
        }
      }
    };

    document.addEventListener('click', handleSmoothScroll);

    return () => {
      document.removeEventListener('click', handleSmoothScroll);
    };
  }, []);

  return (
    <div className="App">
      <Header />
      <main>
        <Hero />
        <Suspense fallback={<SectionFallback />}>
          <ThesisProject />
          <RangerProject />
          <OtherProjects />
          <Skills />
          <Publications />
          <EducationTimeline />
          <Affiliations />
          <CentrifugeExperience />
          <Blog />
          <Gallery />
          <Contact />
        </Suspense>
      </main>
      <Suspense fallback={null}>
        <Footer />
      </Suspense>
    </div>
  );
}

export default App;